<div *ngIf="registration != undefined"
      (click)="showList = false; $event.stopPropagation();"
      class="col-md-12 mb-3">
    <div class="row">
        <div class="col-12">
            <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
            <div class="list-title d-flex">
                <span class="d-flex w-50 pr-1 title">
                    {{ 'Conditions' | translate }} ({{registrationActivityConditionListLength ? registrationActivityConditionListLength : '0'}})
                </span>
            </div>
            <div class="row p-0 m-0 page-table">
                <div class="list-group-collapse duo flex-wrap"
                     cdkDropList
                      [cdkDropListData]="registrationActivityConditionList"
                      (cdkDropListDropped)="dropped($event)">
                    <div cdkDrag *ngFor="let registrationActivityCondition of registrationActivityConditionList; let first = first; let last = last; let i = index"
                         class="{{ disabled ? 'list-item-disabled' : 'list-item' }} {{first ? 'first' : ''}} row">
                        <div (click)="openEdit(registrationActivityCondition);$event.stopPropagation();"
                             class="d-flex justify-content-between w-50 pr-3 list-itemPart first col-12 col-md-6 flex-auto">
                            <div class="d-flex align-items-center w-100">
                                <span>{{getNameOfActivityCondition(registrationActivityCondition) | translate}}</span>
                            </div>
                            <div class="d-flex align-items-center" *ngIf="!disabled">
                                <confirmation [showTrashIcon]="true"
                                              [question]="'confirm.areyousure'"
                                              [extraClasses]="'d-flex'"
                                              (click)="$event.stopPropagation();"
                                              (isConfirmed)="deleteCondition($event, registrationActivityCondition.id)">
                                </confirmation>
                            </div>
                        </div>
                        <div *ngIf="!showDeterminant[i]"
                             class="list-det">
                            <span *ngIf="hasDeterminant(registrationActivityCondition)"
                                  (click)="showDeterminant[i] = !showDeterminant[i];$event.stopPropagation();"
                                  class="list-toggleDet"
                                  tooltip="{{'View determinant' | translate}}">D</span>
                            <span *ngIf="!disabled && !hasDeterminant(registrationActivityCondition)"
                                  (click)="openEdit(registrationActivityCondition, true);$event.stopPropagation();"
                                  class="list-addDet"><i class="far fa-plus"></i>{{'Add Determinant' | translate}}</span>
                        </div>
                        <div *ngIf="showDeterminant[i]"
                             (click)="openEdit(registrationActivityCondition, true)"
                             class="d-flex justify-content-between w-50 pl-3 list-itemPart second col-12 col-md-6">
                            <div class="d-flex align-items-center w-100">
                                <i (click)="showDeterminant[i] = !showDeterminant[i];$event.stopPropagation();"
                                   class="far fa-angle-left d-none d-md-inline-block regulation-determinant-angle-icon"></i>
                                <i (click)="showDeterminant[i] = !showDeterminant[i];$event.stopPropagation();"
                                   class="far fa-angle-up d-sm-inline-block d-md-none regulation-determinant-angle-icon"></i>
                                <query-builder [jsonString]="registrationActivityCondition.jsonDeterminants"
                                               [determinantMapById]="determinantMapById"
                                               [easyToRead]="true"
                                               [noneSelectedText]="'No determinant'"
                                               [readOnly]="true"></query-builder>
                                <i (click)="removeDeterminant(registrationActivityCondition, i);$event.stopPropagation();"
                                   class="fas fa-times btn-xs btn-bordered btn-danger btn-icon d-flex"
                                   style="margin-inline-start:auto;"
                                   *ngIf="!disabled"></i>
                            </div>
                        </div>
                        <div *cdkDragPreview class="col-4">
                            <div>
                                {{getNameOfActivityCondition(registrationActivityCondition) | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-100" style="position:relative;" *ngIf="!disabled">
                    <div class="list-item col-12 col-md-6 last add-item {{showList ? 'opened' : ''}}"
                         (click)="showOrAdd(); $event.stopPropagation();">
                        <div class="d-flex w-100 justify-content-between list-itemPart first">
                            <div class="{{showList ? 'hidden' : ''}}">
                                <span *ngIf="activityConditions?.length > 0 && registrationActivityConditionListLength != activityConditions?.length"><i class="fal fa-plus"></i> {{'Select or add new' | translate}}</span>
                                <span *ngIf="activityConditions?.length == 0 || registrationActivityConditionListLength == activityConditions?.length"><i class="fal fa-plus"></i> {{'Add new' | translate}}</span>
                            </div>
                            <input (input)="searchConditionFilter.name" [(ngModel)]="searchConditionFilter.name" (click)="$event.stopPropagation();" placeholder="{{ 'general.search' | translate }}" type="text" class="{{showList ? '' : 'hidden'}} select-search" />
                            <span (click)="openEdit(false);$event.stopPropagation();"
                                   class="addBtn lower services-icon--add ml-auto {{showList ? '' : 'hidden'}}">{{'Add' | translate}}</span>
                        </div>
                    </div>

                    <div class="w-50 list-item-group limit-height-200 vertical-scroll" *ngIf="activityConditions?.length > 0">
                      <div *ngFor="let activityCondition of activityConditions | filterBy: searchConditionFilter; let first = first; let last = last; let i = index">
                        <div *ngIf="showActivityConditions[activityCondition.id]"
                              (click)="addRegistrationActivityCondition(activityCondition);$event.stopPropagation();"
                              class="list-item w-100 select-item {{showList ? '' : 'hidden'}} {{last ? 'last' : ''}}">
                            <div class="d-flex justify-content-between pr-3 list-itemPart first">
                                <div class="d-flex align-items-center w-100">
                                    <div>{{activityCondition.name}}</div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
